import { z } from 'zod'

export const GetUserSchema = z.object({
  avatar: z
    .object({
      url: z.string(),
    })
    .nullish(),
  created_at: z.coerce.date().nullish(),
  email: z.email(),
  id: z.coerce.number(),
  last_name: z.string().nullish(),
  locale: z.string().nullish(),
  name: z.string(),
  phone: z.string().nullish(),
  phone_country: z.string().length(2).nullish(),
  phone_formatted: z.string().nullish(),
  pid: z.string().nullish(),
  updated_at: z.coerce.date().nullish(),
})

export const GetLastAuthSchema = z.object({
  id: z.number(),
  logged_at: z.coerce.date(),
  method: z.string(),
})

export const GetUserStatusSchema = z.object({ alias: z.string(), title: z.string() })

export const AuthTokenResponseSchema = z.object({
  access_token: z.string(),
  expires_in: z.number(),
  token_type: z.enum(['bearer']),
})

export type AuthTokenResponse = z.infer<typeof AuthTokenResponseSchema>
